export default "__VITE_ASSET__d9d5f326__"